<script lang="ts">
    const { class: className }: { class?: string } = $props();
</script>

<svg class={className} viewBox="0 0 44 44">
    <circle cx="22" cy="22" r="6" fill="none" stroke="currentColor" stroke-width="2">
        <animate attributeName="r" from="6" to="20" dur="1.5s" begin="0s" repeatCount="indefinite"></animate>
        <animate attributeName="opacity" from="1" to="0" dur="1.5s" begin="0s" repeatCount="indefinite"></animate>
    </circle>
    <circle cx="22" cy="22" r="6" fill="none" stroke="currentColor" stroke-width="2">
        <animate attributeName="r" from="6" to="20" dur="1.5s" begin="0.5s" repeatCount="indefinite"></animate>
        <animate attributeName="opacity" from="1" to="0" dur="1.5s" begin="0.5s" repeatCount="indefinite"></animate>
    </circle>
</svg>
